import { SECTION_STATUS } from '../constants/patientCard';
import { readLane } from './patientCardLanes';

/**
 * Single source of truth for "the procedures section may be missing rows"
 * (bk-819, F7-F). Drives BOTH `PatientTimeline`'s card-level notice and
 * every `OpdTimelineRow`'s softened empty line, so they read the SAME
 * boolean and can never disagree.
 *
 * True when either:
 *   - the SECTION itself was capped (`status === TRUNCATED`, the 25-plan
 *     fan-out cap over the whole procedures lane), OR
 *   - any individually LOADED plan reports its OWN sittings were cut short
 *     (`sittings_truncated === true`) — this can happen even while the
 *     section status still reads `OK`, so branching on section status
 *     alone would miss it and reproduce the false "No procedures" line.
 *
 * Plans are read through the shared `readLane` guard (Q2), so an UNREADABLE
 * procedures lane contributes no plans here and this stays false — a lane
 * that could not be read is a DIFFERENT state with its own copy, never a
 * truncation.
 */
export function isProceduresTruncated(proceduresSection) {
  if (!proceduresSection) return false;
  if (proceduresSection.status === SECTION_STATUS.TRUNCATED) return true;
  const { items } = readLane(proceduresSection);
  return items.some((plan) => plan?.sittings_truncated === true);
}
